import styled from '@emotion/styled';
import { transparentize } from 'polished';

const Subtitle = styled.h2`
  color: ${props => props.theme.foregroundTextColor};
  background: ${props => transparentize(0.78, props.theme.foregroundTextColor)};

  border-radius: 0.2em;

  font-size: 2rem;

  padding-top: 0.4em;
  padding-bottom: 0.4em;

  margin-left: 1.5em;
  margin-right: 1.5em;
  margin-top: 0.5em;
  margin-bottom: 1em;

  text-align: center;
`;

export default Subtitle;
